<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h2>
          {{ title }}
        </h2>
      </v-card-title>

      <div>
        <v-data-table
          :headers="headers"
          :items="asModels()"
          hide-actions
          class="elevation-1"
          no-data-text="No models have been created yet"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-btn
                @click="editItem(props.item)"
              >
                {{ props.item.name }}
              </v-btn>
            </td>
            <td>{{ props.item.description }}</td>
            <td>{{ props.item.startDate }}</td>
            <td>{{ props.item.endDate }}</td>
            <td>{{ props.item.statusDesc() }}</td>
            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="editItem(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>

    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Model from '@/classes/Model.class'

export default {
  data () {
    return {
      title: 'Models',
      headers: [
        {
          text: 'Model Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Description',
          align: 'left',
          sortable: true,
          value: 'description'
        },
        {
          text: 'Start Date',
          align: 'left',
          sortable: true,
          value: 'startDate'
        },
        {
          text: 'End Date',
          align: 'left',
          sortable: true,
          value: 'endDate'
        },
        {
          text: 'Status',
          align: 'left',
          sortable: true,
          value: 'status'
        }
      ]
    }
  },
  mounted () {
    if (this.modelsCount === 0) {
      console.log('should load model models')
      this.loadModels()
    }
  },

  watch: {
    models: function (val) {
      if (val !== undefined) {
        this.asModels()
      }
    }
  },

  computed: {
    ...mapGetters({
      models: 'models/models',
      modelsCount: 'models/modelsCount'
    })
  },

  methods: {
    ...mapActions({
      clearModels: 'models/clearModels',
      loadModels: 'models/loadModels',
      setModelID: 'models/setModelID',
      setShowModelList: 'models/setShowModelList',
      deleteModel: 'models/deleteModel',
      updateModel: 'models/updateModel'
    }),
    asModels () {
      console.log('asModels: models', this.models)
      if (this.models !== undefined) {
        var plist = []
        for (var i = 0; i < this.models.length; i++) {
          var lineItem = new Model(this.models[i])
          plist.push(lineItem)
        }
        return plist
      }
    },

    editItem (item) {
      this.editedItem = Object.assign({}, item)

      this.setModelID({ uuid: this.editedItem.uuid })
      this.setShowModelList(false)
      this.$router.push(
        '/model-models/' + this.slug(this.editedItem.uuid))
    },

    deleteItem (item) {
      if (confirm('Are you sure you want to delete this portfolio?')) {
        this.deleteModel(item)

        if (this.modelsCount === 0) {
          console.log('is this necessary?')
          //   this.setSearchStatus(1)
        }
      }
    },

    statusDesc1 (status) {
      return new Model({ status: status }).status
    },

    slug (name) {
      return name.replace(/\s+/g, '-')
    },
    unslug (slug) {
      return slug.replace()
    }
  }
}
</script>

<style scoped>

</style>
